import { ActionTypes } from "../constants/action-types";
import { fromJS } from "immutable";
import { handleActions } from "redux-actions";

export const initialState = fromJS({
  reports: [],
  pending: true,
});

export const actions = {
  [ActionTypes.getReports]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null || payload === undefined) {
        return state.merge({ pending, error });
      }
      const newState = {
        ...state.toJS(),
        pending: false,
        reports: payload,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.deleteReport]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null || payload === undefined) {
        return state.merge({ pending, error });
      }
      const { reportId } = payload;
      const newList = state.get("reports").filter((item) => item.get("id") !== reportId);
      const newState = {
        ...state.toJS(),
        pending: false,
        reports: newList.toJS(),
      };
      return fromJS(newState);
    },
  },
};

export const report = handleActions(actions, initialState);
